export default __webpack_public_path__ + "static/media/work-8.1653f8f2.jpg";